import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { Country } from 'app/shared/models';

@Injectable()
export class CountryService {
  private countries: Country[];
  private countryApiUrl = this.config.getConfig('apiUrl') + '/v1/Countries';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization-ApiKey': this.config.getConfig('apiKey')
  });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getCountries(): Promise<Country[]> {
    return this.countries
      ? Promise.resolve(this.countries)
      : this.http
          .get<Country[]>(this.countryApiUrl, { headers: this.headers })
          .toPromise()
          .then(response => {
            this.countries = response;
            return this.countries;
          })
          .catch(error => Promise.reject(error.message || error));
  }
}
